import React from 'react';
import styles from './TabsContent.module.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

export const DuoPelletNDescription = () => {

  return (
    <div className={styles.container}>
      <p className={styles.mainTitle}>Cazanul pe peleți <span className={styles.highlight}>Duo Pellet N</span></p>
      <p className={styles.text}>
        Cazanul pe peleți Duo Pellet N este prevăzut pentru încălzirea locuințelor și unităților industriale în modul automat. Peleții sunt transportați cu ajutorul șnecului din buncăr, care se afla lângă cazan.
        Combustibilul principal pentru aceasta centrala Duo Pellet se constituie combustibil fracționar ( maxim de 25 mm), peleți din lemn și agropeleți (paie, coji de floarea soarelui, stuf, semințe s.a.)
      </p>
      <div className={styles.guaranteeBox}>
        <div className={styles.guaranteeContent}>
          <i className="fa-solid fa-triangle-exclamation" />
          <p>
            Perfectă lui exploatare cu sistem alimentare șnec depinde de corectă lui instalare, folosirea combustibilului potrivit și curățarea să în timp util.
            <p className={styles.text}>
              Alimentarea acestuia se poate face și manual cu combustibil solid.
            </p>
          </p>
        </div>
      </div>
      <h1 className={styles.title}>Alimentarea cu combustibil</h1>
      <p className={styles.text}>
        Cazanul pe peleți  Duo Pellet N este unul universal. Exista posibilitatea amplasării buncărului de combustibil atât în dreapta cazanului, cat și în stânga acestuia.Centrala poate funcționa și în afara sezonului rece, în sistemul de încălzire a apei legat de un boiler. După aprinderea cazanului nu este necesara o supraveghere permanentă a acestuia. Funcționarea centralei poate fi neîntreruptă pe tot parcursul sezonului de încălzire . Cel mai mare avantaj al centralei Duo Pellet N consta în faptul că dacă am alimentat buncărul acestuia o data nu mai este nevoie să-l mai alimentam o perioada îndelungată de la 3 la 7 zile și mai mult, în funcție de mărimea acestuia.
      </p>
      <h1 className={styles.title}>Caracteristicile cazanului</h1>
      <p className={styles.text}>
        Cazanul Duo Pellet N este un cazan cu temperatura joasă și alimentare automată în camera de combustie și arzător de retortă. Randamentul acestuia  fiind de 93%. Se poate alimenta și manual datorită grătarului realizat din țevi fără sudură,prin care circula apa constant din carcasa cu apa a cazanului, ceea ce face imposibilă arderea acestora.
        Cazanul este dotat cu o carcasă ce îl răcește, făcută din foi de oțel cu grosimea de 6mm.
      </p>
      <p className={styles.text}>
        Camera de ardere foarte mare este amplasată sub schimbătorul de căldură cu patru cai, foarte eficient.
      </p>
      <p className={styles.text}>
        Combustibilul pentru procesul de ardere este alimentat automat de la buncărul care este situat lângă cazan cu ajutorul mecanismului de alimentare cu șnec. In retorta de fonta, are loc procesul de ardere a combustibilului cu ajutorul aerului, care este suflat cu ajutorul unui ventilator de alimentare. Pentru distribuirea uniforma a materialelor de ardere prin intermediul schimbătorului de căldură în cazan, este folosit un separator din fonta -deflector, care este situat deasupra retortului.
      </p>
      <p className={styles.text}>
        Cenușa ce rezulta în urma arderii,se aduna pe marginea retortului  și se varsă în partea inferioară a cazanului.
      </p>
      <p className={styles.text}>
        Controlerul efectuează măsurători permanente ale temperaturii apei în cazan și în baza acestor date controlează funcționarea alimentării automate a combustibilului și a ventilatorului. Este prevăzută o conexiune cu controlerul pompei de circulație a sistemului de încălzire. Cazanul mai beneficiază de un sistem de avarie pentru stingerea de urgență a alimentatorului, al cărui senzor măsoară constant temperatura în buncărul de combustibil și în cazul temperaturii ridicate injectează o doză de apa dintr-un rezervor, suficientă pentru a stinge eventual incendiu din conducta dintre buncăr și retortă.
      </p>
      <p className={styles.text}>
        Ieșirea pentru coșul de evacuare este rotunda și se afla pe spatele cazanului.
      </p>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Parametri</th>
              <th></th>
              <th>U.M.</th>
              <th colSpan="11">Duo Pellet N</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Puterea nominală a cazanului</td>
              <td></td>
              <td>kW</td>
              <td>21</td>
              <td>27</td>
              <td>33</td>
              <td>40</td>
              <td>50</td>
              <td>62</td>
              <td>75</td>
              <td>95</td>
              <td>120</td>
              <td>150</td>
              <td>200</td>
            </tr>
            <tr>
              <td>Suprafața schimbătorului de căldură</td>
              <td></td>
              <td>m²</td>
              <td>1,9</td>
              <td>2,3</td>
              <td>2,6</td>
              <td>3,1</td>
              <td>3,6</td>
              <td>4,5</td>
              <td>5,0</td>
              <td>6,0</td>
              <td>8,2</td>
              <td>9,8</td>
              <td>11,3</td>
            </tr>
            <tr>
              <td>Volumul buncărului</td>
              <td></td>
              <td>dm³</td>
              <td>215</td>
              <td>215</td>
              <td>240</td>
              <td>310</td>
              <td>340</td>
              <td>380</td>
              <td>460</td>
              <td>540</td>
              <td>620</td>
              <td>620</td>
              <td>620</td>
            </tr>
            <td rowSpan="5">Mărimea camerei de ardere suplimentară</td>
            <tr>
              <td>Adâncimea</td>
              <td>l</td>
              <td>84</td>
              <td>84</td>
              <td>92</td>
              <td>105</td>
              <td>120</td>
              <td>135</td>
              <td>162</td>
              <td>194</td>
              <td>220</td>
              <td>380</td>
              <td>440</td>
            </tr>
            <tr>
              <td>Lățimea</td>
              <td>mm</td>
              <td>320</td>
              <td>320</td>
              <td>370</td>
              <td>370</td>
              <td>420</td>
              <td>500</td>
              <td>500</td>
              <td>640</td>
              <td>740</td>
              <td>740</td>
              <td>740</td>
            </tr>
            <tr>
              <td>Înălțimea</td>
              <td>mm</td>
              <td>310</td>
              <td>310</td>
              <td>360</td>
              <td>360</td>
              <td>350</td>
              <td>350</td>
              <td>320</td>
              <td>320</td>
              <td>300</td>
              <td>300</td>
              <td>340</td>
            </tr>
            <tr>
              <td>Volum</td>
              <td>dm³</td>
              <td>39</td>
              <td>44</td>
              <td>60</td>
              <td>69</td>
              <td>77</td>
              <td>88</td>
              <td>104</td>
              <td>120</td>
              <td>157</td>
              <td>182</td>
              <td>249</td>
            </tr>
            <tr>
              <td>Volumul apei din cazan</td>
              <td></td>
              <td>l</td>
              <td>84</td>
              <td>84</td>
              <td>92</td>
              <td>105</td>
              <td>120</td>
              <td>135</td>
              <td>162</td>
              <td>194</td>
              <td>220</td>
              <td>380</td>
              <td>440</td>
            </tr>
            <tr>
              <td>Greutatea cazanului fără apă</td>
              <td></td>
              <td>kg</td>
              <td>430</td>
              <td>430</td>
              <td>460</td>
              <td>490</td>
              <td>520</td>
              <td>580</td>
              <td>800</td>
              <td>860</td>
              <td>880</td>
              <td>1320</td>
              <td>1510</td>
            </tr>
            <tr>
              <td>Temperatura gazelor arse la evacuare</td>
              <td></td>
              <td>°C</td>
              <td colSpan="11">100 - 180</td>
            </tr>
            <tr>
              <td>Temperatura apei minim recomandata</td>
              <td></td>
              <td>°C</td>
              <td colSpan="11">58</td>
            </tr>
            <tr>
              <td>Temperatura maximă a apei</td>
              <td></td>
              <td>°C</td>
              <td colSpan="11">90</td>
            </tr>
            <tr>
              <td>Presiunea nominală a apei (maxim)</td>
              <td></td>
              <td>MPa</td>
              <td>0,15</td>
              <td>0,15</td>
              <td>0,15</td>
              <td>0,15</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
            </tr>
            <tr>
              <td>Consumul de energie electrică, min</td>
              <td></td>
              <td>W</td>
              <td>180</td>
              <td>180</td>
              <td>180</td>
              <td>180</td>
              <td>350</td>
              <td>350</td>
              <td>430</td>
              <td>430</td>
              <td>430</td>
              <td>430</td>
              <td>430</td>
            </tr>
            <tr>
              <td>Diametrul extern racord coș</td>
              <td></td>
              <td>mm</td>
              <td>159</td>
              <td>159</td>
              <td>178</td>
              <td>178</td>
              <td>219</td>
              <td>219</td>
              <td>248</td>
              <td>248</td>
              <td>298</td>
              <td>298</td>
              <td>298</td>
            </tr>
            <tr>
              <td>Diametru conexiune rețelei de apă</td>
              <td></td>
              <td>mm</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>65</td>
              <td>65</td>
              <td>80</td>
              <td>80</td>
              <td>80</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th colSpan="14">Dimensiuni pentru burlan</th>

            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Secțiunea transversală</td>
              <td></td>
              <td>cm²</td>
              <td>201</td>
              <td>201</td>
              <td>248</td>
              <td>248</td>
              <td>377</td>
              <td>377</td>
              <td>452</td>
              <td>452</td>
              <td>660</td>
              <td>660</td>
              <td>660</td>
            </tr>
            <tr>
              <td>Diametru intern</td>
              <td></td>
              <td>mm</td>
              <td>160</td>
              <td>160</td>
              <td>180</td>
              <td>180</td>
              <td>220</td>
              <td>220</td>
              <td>250</td>
              <td>250</td>
              <td>300</td>
              <td>300</td>
              <td>300</td>
            </tr>
            <tr>
              <td>Înălțime (minim permisă)</td>
              <td></td>
              <td>m</td>
              <td>5</td>
              <td>5</td>
              <td>5</td>
              <td>5</td>
              <td>6</td>
              <td>6</td>
              <td>6</td>
              <td>7</td>
              <td>7</td>
              <td>7</td>
              <td>10</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div >
  );
};

export const DuoPelletNDimensions = () => {
  const data = [
    { param: "B", unit: "mm", values: [1140, 1140, 1150, 1190, 1190, 1290, 1580, 1620, 1700, 1950, 1950] },
    { param: "B1", unit: "mm", values: [540, 540, 560, 570, 570, 610, 720, 720, 860, 1010, 1010] },
    { param: "H", unit: "mm", values: [1580, 1580, 1630, 1680, 1680, 1720, 1800, 1910, 2110, 2190, 2190] },
    { param: "H1", unit: "mm", values: [1530, 1530, 1580, 1630, 1630, 1680, 1760, 1790, 1990, 2070, 2070] },
    { param: "H2", unit: "mm", values: [1385, 1385, 1435, 1485, 1465, 1515, 1565, 1595, 1780, 1832, 1832] },
    { param: "H3", unit: "mm", values: [435, 435, 435, 435, 435, 435, 435, 435, 465, 578, 578] },
    { param: "L", unit: "mm", values: [880, 930, 930, 1000, 1080, 1080, 1180, 1280, 1380, 1640, 1780] },
    { param: "L1", unit: "mm", values: [630, 680, 680, 750, 830, 830, 910, 1010, 1080, 1170, 1300] },
    { param: "D", unit: "mm", values: [159, 159, 178, 178, 219, 219, 248, 248, 298, 298, 298] }
  ]

  const headers = ["Parametri", "U.M.", "21 kW", "27 kW", "33 kW", "40 kW", "50 kW", "62 kW", "75 kW", "95 kW", "120 kW", "150 kW", "200 kW"]

  return (
    <div className={styles.dimensionsContainer}>
      <div className={styles.imageContainer}>
        <img src="/Dimensions/DuoPelletNSchema.png" alt="Descriptive Alt Text" className={styles.centeredImage} />
      </div>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{row.param}</td>
                <td>{row.unit}</td>
                {row.values.map((value, valueIndex) => (
                  <td key={valueIndex}>{value}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};


